module.exports = __webpack_public_path__ + "img/linkedin.f26b22e9.png";